import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "35",
  height: "35"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M30.434 11.367s-.54-2.617-1.266-2.617c-.547 0-2.73 2.457-3.793 3.688a1.97 1.97 0 0 1-1.504.687 1.99 1.99 0 0 1-1.996-1.996c0-.578.246-1.125.688-1.504 1.23-1.062 3.687-3.246 3.687-3.793 0-.727-2.625-1.277-2.625-1.277a8.5 8.5 0 0 0-1.75-.18c-4.824 0-8.75 3.96-8.75 8.832 0 .613.074 1.23.223 1.875L4.285 23.98a4.795 4.795 0 0 0 .004 6.711 4.67 4.67 0 0 0 3.34 1.391c1.266 0 2.45-.496 3.324-1.379l9.086-8.926c.625.098 1.234.098 1.836.098 4.906 0 8.75-3.809 8.75-8.668 0-.617-.062-1.234-.191-1.84m0 0",
  style: {"stroke":"none","fill-rule":"nonzero","fill":"#000","fill-opacity":"1"}
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }